const GAMANZA_MENU_CATEGORIES = [
  {
    category: 'gamanza_missions',
    iconClass: 'fas fa-tasks',
    feature: 'missions',
    labels: { es: 'Misiones', en: 'Missions', pt: 'Missões' }
  },
  {
    category: 'gamanza_tournaments',
    iconClass: 'fas fa-trophy',
    feature: 'tournaments',
    labels: { es: 'Torneos', en: 'Tournaments', pt: 'Torneios' }
  }
];

const GAMANZA_PAGE_CATEGORIES = [
  ...GAMANZA_MENU_CATEGORIES,
  {
    category: 'gamanza_reward_shop',
    feature: 'rewardShop'
  }
];

export function hasGamanzaAccess(skin, user) {
  const gamanza = skin?.gamanza;
  const userId = user?.user_data?.data?.user_id;
  const allowedUserIds = gamanza?.allowedUserIds;
  const hasAccess = !Array.isArray(allowedUserIds) ||
    allowedUserIds.length === 0 ||
    allowedUserIds.map(String).includes(String(userId));

  return Boolean(user?.token && gamanza?.enabled && hasAccess);
}

export function getGamanzaMenuCategories(skin, user, gamanzaReady, language = 'es') {
  if (!hasGamanzaAccess(skin, user) || !gamanzaReady) {
    return [];
  }

  return GAMANZA_MENU_CATEGORIES
    .filter(({ feature }) => skin.gamanza.mainFrame?.[feature])
    .map(({ feature, labels, iconClass, ...category }) => {
      const configuredIcon = skin?.gamanza?.mainFrame?.menuIcons?.[feature];

      return {
        ...category,
        icon: configuredIcon,
        iconClass: configuredIcon ? undefined : iconClass,
        active: true,
        name: labels[language] || labels.es
      };
    });
}

export function getGamanzaPageCategory(skin, user, gamanzaReady, category) {
  if (!hasGamanzaAccess(skin, user) || !gamanzaReady) {
    return null;
  }

  const page = GAMANZA_PAGE_CATEGORIES.find((item) => item.category === category);
  if (!page || !skin.gamanza.mainFrame?.[page.feature]) {
    return null;
  }

  return {
    category: page.category,
    active: true
  };
}

export function isGamanzaMenuCategory(category) {
  return GAMANZA_MENU_CATEGORIES.some((item) => item.category === category);
}
